import { checkInfoAndGenerateRows } from '../../helpers';

/**
 * Retrieves the combined bill for a specific organization and date from Firestore.
 *
 * @param {Object} combinedOrg - The combined organization object.
 * @param {Date} billDate - The date of the bill.
 * @param {Object} firestore - The Firestore instance for database operations.
 * @returns {Object} The combined bill details including rows, subTotal, and prepago if available.
 */
export async function getCombinedBill(combinedOrg, billDate, firestore) {
  try {
    const billingRes = await firestore
      .collection('bills')
      .where('organizationId', '==', combinedOrg.id)
      .where('date', '==', billDate.format('YYYY-MM'))
      .get();
    if (billingRes.empty) {
      console.warn(
        `getCombinedBill >> No billing found for the given organization ${
          combinedOrg.displayName
        } and date ${billDate.format('YYYY-MM')}.`,
      );
      return {};
    }
    const bill = { ...billingRes.docs[0].data(), id: billingRes.docs[0].id };

    if (bill) {
      const rows = checkInfoAndGenerateRows(bill, combinedOrg.templates);
      const subTotal = generateSubTotal(rows);
      return { rows, subTotal, prepago: bill.prepago };
    }
  } catch (error) {
    console.error('getCombinedBill', error);
  }
}
const generateSubTotal = (rows) => {
  if (rows && rows.length > 0) {
    const sub = rows.reduce((total, row) => {
      if (typeof row.price === 'number') {
        return row.price + total;
      }
      return total;
    }, 0);
    return sub;
  }
  return [];
};
